import {
  StyleProp, Text, TextStyle, View,
} from 'react-native';
import React from 'react';
import { TranslateProp } from '../../common-types';

interface IProp {
  text: string;
  style: StyleProp<TextStyle>;
}

const BulletCharacter = '\u2022';

export default function BulletPointText({
  text,
  style,
}: IProp) {
  return (
    <View>
      <Text style={style}>{`${BulletCharacter} ${text}`}</Text>
    </View>
  );
}
